import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
} from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { DmButtonLibComponent } from '@everymatrix-base-components/dm-button-lib';

@Component({
  selector: 'lib-domains-overload-modal',
  standalone: true,
  imports: [DialogModule, DmButtonLibComponent],
  template: `
    <p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '460px' }">
      <div class="modal-container">
        <div class="warning-container">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M11.9998 7.99999V12M11.9998 16H12.0098M10.6151 2.89171L2.39019 17.0983C1.93398 17.8863 1.70588 18.2803 1.73959 18.6037C1.769 18.8857 1.91677 19.142 2.14613 19.3088C2.40908 19.5 2.86435 19.5 3.77487 19.5H20.2246C21.1352 19.5 21.5904 19.5 21.8534 19.3088C22.0827 19.142 22.2305 18.8857 22.2599 18.6037C22.2936 18.2803 22.0655 17.8863 21.6093 17.0983L13.3844 2.89171C12.9299 2.10654 12.7026 1.71396 12.4061 1.58211C12.1474 1.4671 11.8521 1.4671 11.5935 1.58211C11.2969 1.71396 11.0696 2.10655 10.6151 2.89171Z"
              stroke="#F08E0D"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="title">
        <span>{{ action()}}</span>
        <span>{{' Report With All Domains'}}</span>
        </div>
        <div class="description">
          <span
            >All domains are selected, which can overload the database and
            negatively affect performance. <br />Are you sure you want to select
            all domains?</span
          >
        </div>
      </div>
      <ng-template pTemplate="footer">
        <div
          style="width: 100%; display: flex; flex-direction: row; justify-content: space-between"
        >
          <lib-dm-button-lib
            text="Back to Settings"
            size="medium"
            variant="secondary-outlined"
            (outsideClickEmitter)="visible.set(false)"
          >
            <div class="dm-button-icon" icon-left>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.5899 3.57733C10.9153 3.90277 10.9153 4.4304 10.5899 4.75584L6.17916 9.16659H15.834C16.2942 9.16659 16.6673 9.53968 16.6673 9.99992C16.6673 10.4602 16.2942 10.8333 15.834 10.8333H6.17916L10.5899 15.244C10.9153 15.5694 10.9153 16.0971 10.5899 16.4225C10.2645 16.7479 9.73683 16.7479 9.4114 16.4225L3.57806 10.5892C3.25263 10.2637 3.25263 9.7361 3.57806 9.41066L9.4114 3.57733C9.73683 3.25189 10.2645 3.25189 10.5899 3.57733Z"
                  fill="#5D6983"
                />
              </svg>
            </div>
          </lib-dm-button-lib>
          <lib-dm-button-lib
            [text]="action() + ' Report'"
            size="medium"
            variant="primary-filled"
            (outsideClickEmitter)="
              confirm.emit({confirm: true, isSaveMode: isSaveMode() }); visible.set(false)
            "
          >
            <div class="dm-button-icon" icon-left>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.8333 2.51651C10.6786 2.50241 10.4493 2.49997 10.0098 2.49997H7.33333C6.61952 2.49997 6.13427 2.50062 5.7592 2.53126C5.39385 2.56111 5.20702 2.61522 5.07668 2.68163C4.76308 2.84142 4.50811 3.09638 4.34832 3.40999C4.28192 3.54032 4.22781 3.72716 4.19796 4.0925C4.16732 4.46758 4.16667 4.95282 4.16667 5.66664V14.3333C4.16667 15.0471 4.16732 15.5324 4.19796 15.9074C4.22781 16.2728 4.28192 16.4596 4.34832 16.59C4.50811 16.9036 4.76308 17.1585 5.07668 17.3183C5.20702 17.3847 5.39385 17.4388 5.7592 17.4687C6.13427 17.4993 6.61952 17.5 7.33333 17.5H12.6667C13.3805 17.5 13.8657 17.4993 14.2408 17.4687C14.6061 17.4388 14.793 17.3847 14.9233 17.3183C15.2369 17.1585 15.4919 16.9036 15.6517 16.59C15.7181 16.4596 15.7722 16.2728 15.802 15.9074C15.8327 15.5324 15.8333 15.0471 15.8333 14.3333V8.32349C15.8333 7.88407 15.8309 7.65478 15.8168 7.50003L12.9734 7.50003C12.7631 7.50006 12.5583 7.50008 12.3848 7.48591C12.1943 7.47035 11.9695 7.43362 11.7433 7.31837C11.4297 7.15858 11.1748 6.90362 11.015 6.59001C10.8997 6.36383 10.863 6.13905 10.8475 5.94856C10.8333 5.77509 10.8333 5.57026 10.8333 5.35993L10.8333 2.51651ZM11.9947 1.12494C11.8064 1.04056 11.6105 0.973705 11.4093 0.925405C11.0237 0.832836 10.6239 0.833026 10.0947 0.833278C10.0668 0.833291 10.0385 0.833305 10.0098 0.833305L7.29892 0.833304C6.62811 0.833293 6.07448 0.833285 5.62348 0.870133C5.15506 0.908404 4.72448 0.99054 4.32003 1.19662C3.69283 1.51619 3.18289 2.02613 2.86331 2.65334C2.65724 3.05778 2.5751 3.48837 2.53683 3.95678C2.49998 4.40778 2.49999 4.96141 2.5 5.63222V14.3677C2.49999 15.0385 2.49998 15.5922 2.53683 16.0432C2.5751 16.5116 2.65724 16.9422 2.86331 17.3466C3.18289 17.9738 3.69283 18.4837 4.32003 18.8033C4.72448 19.0094 5.15506 19.0915 5.62348 19.1298C6.07447 19.1667 6.6281 19.1666 7.2989 19.1666H12.7011C13.3719 19.1666 13.9255 19.1667 14.3765 19.1298C14.8449 19.0915 15.2755 19.0094 15.68 18.8033C16.3072 18.4837 16.8171 17.9738 17.1367 17.3466C17.3428 16.9422 17.4249 16.5116 17.4632 16.0432C17.5 15.5922 17.5 15.0385 17.5 14.3677V8.32349C17.5 8.29482 17.5 8.26653 17.5 8.2386C17.5003 7.70943 17.5005 7.3096 17.4079 6.92402C17.3597 6.72341 17.2931 6.52802 17.2091 6.34028C17.2039 6.32804 17.1984 6.31596 17.1926 6.30404C17.1382 6.18621 17.0768 6.0715 17.0088 5.96051C16.8016 5.62241 16.5188 5.33982 16.1444 4.96581C16.1246 4.94607 16.1046 4.92608 16.0843 4.90581L13.4275 2.24896C13.4072 2.22868 13.3872 2.20867 13.3675 2.1889C12.9935 1.81455 12.7109 1.53169 12.3728 1.3245C12.2614 1.25622 12.1462 1.19464 12.0278 1.14003C12.0169 1.13477 12.0058 1.12974 11.9947 1.12494ZM12.5 3.67848V5.33336C12.5 5.58047 12.5006 5.71568 12.5086 5.81284C12.5089 5.8167 12.5092 5.82036 12.5095 5.82382C12.513 5.82414 12.5167 5.82446 12.5205 5.82478C12.6177 5.83272 12.7529 5.83336 13 5.83336H14.6549L12.5 3.67848ZM5.83333 10.8333C5.83333 10.3731 6.20643 9.99997 6.66667 9.99997H13.3333C13.7936 9.99997 14.1667 10.3731 14.1667 10.8333C14.1667 11.2935 13.7936 11.6666 13.3333 11.6666H6.66667C6.20643 11.6666 5.83333 11.2935 5.83333 10.8333ZM5.83333 14.1666C5.83333 13.7064 6.20643 13.3333 6.66667 13.3333H11.6667C12.1269 13.3333 12.5 13.7064 12.5 14.1666C12.5 14.6269 12.1269 15 11.6667 15H6.66667C6.20643 15 5.83333 14.6269 5.83333 14.1666Z"
                  fill="white"
                />
              </svg>
            </div>
          </lib-dm-button-lib>
        </div>
      </ng-template>
    </p-dialog>
  `,
  styleUrls: ['./domains-overload-modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DomainsOverloadModalComponent {
  isSaveMode = input(false);
  visible = model(false);
  action = model('');
  confirm = output<{confirm: boolean, isSaveMode: boolean}>();
}
